import {
  AP_PENDING,
  AP_BOOTSTRAP,
  AP_SUBMIT,
  AP_CHECKIN_SUBMIT,
  AP_STATUS_OPTIONS,
  AP_ERROR,
  ALL_ERRORS,
  CLEAR_ALL,
} from 'constants/actions.js';

const initialState = {
  pending: false,
  loading: true,
  loadingBootstrap: false,
  submitting: false,
  submittingCheckin: false,
  token: null,
  kind: null, // 'plan' | 'update'
  events: [],
  actions: [],
  activeEvent: null,
  campaignId: null,
  requiredActionsCount: 3,
  statusOptions: [],
  submit: null,
  checkinSubmit: null,
  error: null,
  invalidToken: false,
};

export default function ActionPlan(state = initialState, action) {
  switch (action.type) {
    case AP_PENDING:
      return {
        ...state,
        pending: true,
        loading: true,
        loadingBootstrap: action?.meta?.phase === 'bootstrap',
        submitting: action?.meta?.phase === 'submit',
        submittingCheckin: action?.meta?.phase === 'checkin_submit',
        error: null,
        invalidToken: false,
      };
    case AP_BOOTSTRAP:
      return {
        ...state,
        pending: false,
        loading: false,
        loadingBootstrap: false,
        submitting: false,
        submittingCheckin: false,
        token: action.payload?.token ?? null,
        kind: action.payload?.kind ?? null,
        events: action.payload?.events ?? [],
        actions: action.payload?.actions ?? [],
        activeEvent: action.payload?.activeEvent ?? null,
        campaignId: action.payload?.campaignId ?? null,
        requiredActionsCount: action.payload?.requiredActionsCount ?? state.requiredActionsCount,
        error: null,
        invalidToken: false,
      };
    case AP_SUBMIT:
      return {
        ...state,
        pending: false,
        loading: false,
        loadingBootstrap: false,
        submitting: false,
        submittingCheckin: false,
        submit: action.payload,
        error: null,
        invalidToken: false,
      };
    case AP_STATUS_OPTIONS:
      return {
       ...state,
       statusOptions: Array.isArray(action.payload) ? action.payload : [],
      };
    case AP_CHECKIN_SUBMIT:
      return {
        ...state,
        pending: false,
        loading: false,
        loadingBootstrap: false,
        submitting: false,
        submittingCheckin: false,
        checkinSubmit: action.payload,
        error: null,
        invalidToken: false,
      };
    case AP_ERROR:
    case ALL_ERRORS:
      {
        const err = action.message ?? action.error ?? action;
        const status = err?.status ?? err?.status_code ?? err?.response?.status ?? null;
      return {
        ...state,
        pending: false,
        loading: false,
        loadingBootstrap: false,
        submitting: false,
        submittingCheckin: false,
        error: err,
        invalidToken: status === 403,
      };
      }
    case CLEAR_ALL:
      return { ...initialState };
    default:
      return state;
  }
}
